<template>
  <div class="statusReportComments">
    <div class="buttons">
      <b-button v-if="getIsSupervisor" id="addNewRowButton" @click="addEntry">
        <i class="bi bi-plus-square"></i>
      </b-button>
    </div>
    <ValidationObserver v-slot="{ invalid }">
      <div class="dataTable">
        <b-table class="w-auto" :items="tableData" :fields="columns" striped sticky-header>
          <template #cell(date)="data">
            <span>{{ returnAsFormatedMoment(data.value) }}</span>
          </template>

          <template #cell(content)="data">
            <ValidationProvider v-if="tableData[data.index].isEdit" v-slot="{ errors }" name="content" rules="required|max:2000">
              <div v-if="tableData[data.index].isEdit" class="inputCenterAlignment">
                <b-form-textarea v-model="tableData[data.index].content" rows="2" max-rows="8" size="sm"></b-form-textarea>
              </div>
              <span class="commentTableErrorMessages">{{ errors[0] }}</span>
            </ValidationProvider>
            <span v-else>{{ data.value }}</span>
          </template>

          <template #cell(fullName)="data">
            {{ data.value }}
          </template>

          <template #cell(visibility)="data">
            <ValidationProvider
              v-if="tableData[data.index].isEdit"
              v-slot="{ errors }"
              :vid="'visibility' + data.index"
              name="visibility"
              rules="required"
            >
              <div v-if="tableData[data.index].isEdit" class="inputCenterAlignment">
                <b-form-select id="formSelect" v-model="tableData[data.index].visibility" :options="visibilityOptions"></b-form-select>
              </div>

              <span class="professorTableErrorMessages">{{ errors[0] }}</span>
            </ValidationProvider>

            <span v-else>
              <span>{{ $t(mapVisibilityIntToString(data.value)) }}</span>
            </span>
          </template>

          <template #cell(edit)="data">
            <b-button
              v-if="currentlyNotEditingOrDeletingEntry(data) && commentIsByAuthor(data)"
              pill
              size="sm"
              :disabled="!commentIsByAuthor(data)"
              @click="editRowHandler(data)"
            >
              <i class="bi bi-pencil-fill icon editButtons"></i>
            </b-button>
            <b-button v-if="!currentlyNotEditingOrDeletingEntry(data)" pill size="sm" :disabled="invalid" @click="confirmEditOrDelete(data)"
              ><i class="bi bi-check2 icon editButtons"></i
            ></b-button>

            <b-button
              v-if="currentlyNotEditingOrDeletingEntry(data) && commentIsByAuthor(data)"
              id="deleteButton"
              pill
              size="sm"
              :disabled="invalid || !commentIsByAuthor(data)"
              @click="promptToConfirmDelete(data)"
            >
              <i class="bi bi-trash-fill icon editButtons"></i>
            </b-button>
            <b-button v-if="!currentlyNotEditingOrDeletingEntry(data)" id="deleteButton" pill size="sm" @click="stopEditingOrDeleting(data)"
              ><i class="bi bi-x icon editButtons"></i
            ></b-button>
          </template>
        </b-table>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { commentDataTableMixin } from './CommentDataTableMixin'
import mapGettersMixin from '../../mixins/mapGettersMixin'
import { processPromisesMixin } from '../../mixins/processPromisesMixin'

import moment from 'moment'
import { generalHelperMethodsMixin } from '../../mixins/generalHelperMethodsMixin'

export default {
  name: 'App',
  components: {
    moment //eslint-disable-line
  },
  mixins: [commentDataTableMixin, processPromisesMixin, mapGettersMixin, generalHelperMethodsMixin],
  props: { statusReportId: Number, commentsURI: String, commentsParams: Object, week: Number },
  data() {
    return {
      localeConsts: {
        statusReportsEditButton: 'WORKREPORTS.EDITBUTTON',
        statusReportsDeleteButton: 'WORKREPORTS.DELETEBUTTON',
        statusReportsDoneButton: 'WORKREPORTS.DONEBUTTON',
        statusReportsDateColumn: 'WORKREPORTS.DATE',
        statusReportsCommentColumn: 'WORKREPORTS.COMMENT',
        statusReportsFromColumn: 'WORKREPORTS.FROM',
        statusReportsVisibilityColumn: 'WORKREPORTS.VISIBILITY'
      },

      fetchedData: [],
      tableData: [],
      idToName: {}
    }
  },

  computed: {
    columns() {
      return [
        {
          key: 'date',
          label: this.$i18n.t(this.localeConsts.statusReportsDateColumn),
          thClass: 'text-center commentTableThStyle',
          tdClass: 'text-center'
        },
        {
          key: 'content',
          label: this.$i18n.t(this.localeConsts.statusReportsCommentColumn),
          thClass: 'text-center commentTableThStyle commentStyle',
          tdClass: 'text-center commentStyle'
        },
        {
          key: 'fullName',
          label: this.$i18n.t(this.localeConsts.statusReportsFromColumn),
          tdClass: 'text-center',
          thClass: 'text-center bg-white commentTableThStyle'
        },
        {
          key: 'visibility',
          label: this.$i18n.t(this.localeConsts.statusReportsVisibilityColumn),
          tdClass: 'text-center',
          thClass: 'text-center commentTableThStyle'
        },
        {
          key: 'edit',
          label: '',
          tdClass: 'text-center',
          thClass: 'text-center commentTableThStyle'
        }
      ]
    },
    maxDate() {
      return moment().format('YYYY-MM-DD hh:mm')
    },
    datePickerNoLabelBool() {
      return false
    },
    visibilityOptions() {
      return [
        { value: 0, text: this.$i18n.t('VISIBILITY.ONLY_ME') },
        { value: 1, text: this.$i18n.t('VISIBILITY.SUPERVISORS_ONLY') },
        { value: 2, text: this.$i18n.t('VISIBILITY.SUPERVISORS_AND_STUDENTS') }
      ]
    }
  },

  watch: {
    //eslint-disable-next-line
    week: function (newValue) {
      this.filterOnWeek(newValue)
    }
  },

  mounted() {
    this.getStatusReportComments()
  }
}
</script>

<style lang="scss">
// table styling

.table .commentTableThStyle {
  background-color: #c1afd1 !important;
  color: #451a6e !important;
}

.inputCenterAlignment {
  display: grid;
  place-items: center;
}
// Table

.workReports {
  width: 100%;
}

.commentStyle {
  line-break: word;
  max-width: 200px;
}

// Inputs

.bigInputs {
  height: 8em;
}

input::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  margin: 0px;
  -webkit-appearance: none;
}
#numberInput {
  width: 50px;
  text-align: center;
}

.buttons {
  display: flex;
  margin-bottom: 15px;
  justify-content: space-between;
  align-items: center;
}
//change, delete, confirm, cancel buttons

.editButtons {
  font-size: 16px;
  color: white;
}

#deleteButton {
  margin-left: 1rem;
}
/*input error messages*/

.commentTableErrorMessages {
  color: red;
  font-size: 12px;
}
</style>
